$(() => {
  // GoogleAPI最寄り駅取得
  $('.js-get-nearest-station').on('click', e => {
    const $getNearestStation = $(e.currentTarget);
    if ($getNearestStation.hasClass('disabled')) {
      return;
    }

    if (!window.confirm('「最寄駅」欄を上書きします。よろしいですか？')) {
      return;
    }

    if (!$('.js-lat').val() || !$('.js-lng').val()) {
      return;
    }

    const btnTxt = $getNearestStation.text();
    $getNearestStation.text('取得中...');

    $.ajax({
      url: $(e.currentTarget).data('url'),
      data: {
        lat: $('.js-lat').val(),
        lng: $('.js-lng').val(),
        id: $('#shop_id').val(),
      },
      dataType: 'script',
    })
      .fail(() =>
        alert(
          '最寄り駅の取得に失敗しました。お手数ですが、JOBLIST運営による対応が完了するまで手動での入力をお願いします。'
        )
      )
      .always(() => {
        $getNearestStation.text(btnTxt);
      });
  });

  // 削除ボタン押下時
  $('.js-station-accesses').on('click', '.js-station-access-destroy', e => {
    const $stationAccess = $(e.currentTarget).closest('.js-station-access');
    $stationAccess.find('input, select').val('').trigger('chosen:updated');
    $stationAccess.find('input[type=hidden]').val(1);
  });
});
